import { useMemo } from 'react';

import { useAppSelector } from 'state/global-state';
import { selectors } from 'state/global-state';

export const useTransformedAppliedOffers = () => {
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);

  return useMemo(() => {
    return appliedOffers.map(({ id, cartId, type, cmsId }) => ({
      id,
      cartId,
      type,
      sanityId: cmsId,
    }));
  }, [appliedOffers]);
};
